import { FC } from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { Card } from 'Elements';

export const SkeletonRequestInformation: FC = () => {
	const { t } = useTranslation();
	const skeletonStyle: React.CSSProperties = {
		height: '20px',
		width: '100%',
		marginBottom: '16px'
	};

	return (
		<Row>
			<Col xl={6}>
				<>
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
				</>
			</Col>
			<Col xl={6}>
				<>
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
					<div className="skeletonStyle" style={skeletonStyle} />
				</>
			</Col>
		</Row>
	);
};
